import * as i0 from '@angular/core';
import { Input, ChangeDetectionStrategy, Component, Directive, NgModule } from '@angular/core';
import * as i1 from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
const _c0 = ["nxAvatar", ""];
const _c1 = ["*"];
class NxAvatarComponent {
  /** Sets the size of the avatar. Default: 'medium'. */
  set size(size) {
    if (this._size !== size) {
      this._size = size;
      this._cdr.markForCheck();
    }
  }
  get size() {
    return this._size;
  }
  constructor(_cdr) {
    this._cdr = _cdr;
    this._size = 'medium';
  }
  static {
    this.ɵfac = function NxAvatarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxAvatarComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxAvatarComponent,
      selectors: [["", "nxAvatar", ""]],
      hostVars: 12,
      hostBindings: function NxAvatarComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("nx-avatar--xsmall", ctx.size === "xsmall")("nx-avatar--small", ctx.size === "small")("nx-avatar--small-medium", ctx.size === "small-medium")("nx-avatar--medium", ctx.size === "medium")("nx-avatar--large", ctx.size === "large")("nx-avatar--xlarge", ctx.size === "xlarge");
        }
      },
      inputs: {
        size: "size"
      },
      attrs: _c0,
      ngContentSelectors: _c1,
      decls: 2,
      vars: 0,
      consts: [[1, "nx-avatar__content-wrapper"]],
      template: function NxAvatarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: ["[_nghost-%COMP%]{background:var(--avatar-background-color);color:var(--avatar-color);border-radius:50%;text-align:center}[_nghost-%COMP%]   .nx-avatar__content-wrapper[_ngcontent-%COMP%]{display:flex;height:100%;justify-content:center;align-items:center;position:relative}[_nghost-%COMP%]     figure{width:100%}.nx-avatar--xsmall[_nghost-%COMP%]{height:var(--avatar-xsmall-size);width:var(--avatar-xsmall-size);min-width:var(--avatar-xsmall-size);font-size:var(--avatar-xsmall-font-size);line-height:var(--avatar-xsmall-line-height);font-weight:var(--avatar-xsmall-font-weight);letter-spacing:var(--avatar-xsmall-letter-spacing)}.nx-avatar--xsmall[_nghost-%COMP%]     nx-icon{font-size:var(--avatar-xsmall-icon-size)}.nx-avatar--small[_nghost-%COMP%]{height:var(--avatar-small-size);width:var(--avatar-small-size);min-width:var(--avatar-small-size);font-size:var(--avatar-small-font-size);line-height:var(--avatar-small-line-height);font-weight:var(--avatar-small-font-weight);letter-spacing:var(--avatar-small-letter-spacing)}.nx-avatar--small[_nghost-%COMP%]     nx-icon{font-size:var(--avatar-small-icon-size)}.nx-avatar--small-medium[_nghost-%COMP%]{height:var(--avatar-small-medium-size);width:var(--avatar-small-medium-size);min-width:var(--avatar-small-medium-size);font-size:var(--avatar-small-medium-font-size);line-height:var(--avatar-small-medium-line-height);font-weight:var(--avatar-small-medium-font-weight);letter-spacing:var(--avatar-small-medium-letter-spacing)}.nx-avatar--small-medium[_nghost-%COMP%]     nx-icon{font-size:var(--avatar-small-medium-icon-size)}.nx-avatar--medium[_nghost-%COMP%]{height:var(--avatar-medium-size);width:var(--avatar-medium-size);min-width:var(--avatar-medium-size);font-size:var(--avatar-medium-font-size);line-height:var(--avatar-medium-line-height);font-weight:var(--avatar-medium-font-weight);letter-spacing:var(--avatar-medium-letter-spacing)}.nx-avatar--medium[_nghost-%COMP%]     nx-icon{font-size:var(--avatar-medium-icon-size)}.nx-avatar--large[_nghost-%COMP%]{height:var(--avatar-large-size);width:var(--avatar-large-size);min-width:var(--avatar-large-size);font-size:var(--avatar-large-font-size);line-height:var(--avatar-large-line-height);font-weight:var(--avatar-large-font-weight);letter-spacing:var(--avatar-large-letter-spacing)}.nx-avatar--large[_nghost-%COMP%]     nx-icon{font-size:var(--avatar-large-icon-size)}.nx-avatar--xlarge[_nghost-%COMP%]{height:var(--avatar-xlarge-size);width:var(--avatar-xlarge-size);min-width:var(--avatar-xlarge-size);font-size:var(--avatar-xlarge-font-size);line-height:var(--avatar-xlarge-line-height);font-weight:var(--avatar-xlarge-font-weight);letter-spacing:var(--avatar-xlarge-letter-spacing)}.nx-avatar--xlarge[_nghost-%COMP%]     nx-icon{font-size:var(--avatar-xlarge-icon-size)}.is-button[_nghost-%COMP%]{border:none;padding:0;cursor:pointer;position:relative}.is-button[_nghost-%COMP%]:before, .is-button[_nghost-%COMP%]     .nx-image:after{content:\"\";width:100%;height:100%;position:absolute;border-radius:50%;top:0;left:0}.is-button[_nghost-%COMP%]:hover:not(:disabled):before{background-color:#0000001a}.is-button[_nghost-%COMP%]:hover:not(:disabled)     .nx-image:after{background-color:#0000001a}.is-button[_nghost-%COMP%]:active:not(:disabled):before{background-color:#0003}.is-button[_nghost-%COMP%]:active:not(:disabled)     .nx-image:after{background-color:#0003}.is-button[_nghost-%COMP%]:disabled{cursor:not-allowed;opacity:var(--avatar-disabled-opacity)}.is-button[_nghost-%COMP%]:focus{outline:none}.is-button[_nghost-%COMP%]::-moz-focus-inner{border:0}.is-button.cdk-keyboard-focused[_nghost-%COMP%]{box-shadow:var(--focus-box-shadow)}@media screen and (forced-colors: active),(forced-colors: active){.is-button.cdk-keyboard-focused[_nghost-%COMP%]{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}@media screen and (forced-colors: active){[_nghost-%COMP%]{border:2px solid CanvasText}.is-button[_nghost-%COMP%]{border:2px solid buttonText;background-color:buttonFace}.is-button[_nghost-%COMP%]:disabled{opacity:1;border-color:GrayText;color:GrayText}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxAvatarComponent, [{
    type: Component,
    args: [{
      selector: '[nxAvatar]',
      template: `<div class="nx-avatar__content-wrapper">
        <ng-content></ng-content>
    </div>`,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        '[class.nx-avatar--xsmall]': 'size === "xsmall"',
        '[class.nx-avatar--small]': 'size === "small"',
        '[class.nx-avatar--small-medium]': 'size === "small-medium"',
        '[class.nx-avatar--medium]': 'size === "medium"',
        '[class.nx-avatar--large]': 'size === "large"',
        '[class.nx-avatar--xlarge]': 'size === "xlarge"'
      },
      standalone: true,
      styles: [":host{background:var(--avatar-background-color);color:var(--avatar-color);border-radius:50%;text-align:center}:host .nx-avatar__content-wrapper{display:flex;height:100%;justify-content:center;align-items:center;position:relative}:host ::ng-deep figure{width:100%}:host.nx-avatar--xsmall{height:var(--avatar-xsmall-size);width:var(--avatar-xsmall-size);min-width:var(--avatar-xsmall-size);font-size:var(--avatar-xsmall-font-size);line-height:var(--avatar-xsmall-line-height);font-weight:var(--avatar-xsmall-font-weight);letter-spacing:var(--avatar-xsmall-letter-spacing)}:host.nx-avatar--xsmall ::ng-deep nx-icon{font-size:var(--avatar-xsmall-icon-size)}:host.nx-avatar--small{height:var(--avatar-small-size);width:var(--avatar-small-size);min-width:var(--avatar-small-size);font-size:var(--avatar-small-font-size);line-height:var(--avatar-small-line-height);font-weight:var(--avatar-small-font-weight);letter-spacing:var(--avatar-small-letter-spacing)}:host.nx-avatar--small ::ng-deep nx-icon{font-size:var(--avatar-small-icon-size)}:host.nx-avatar--small-medium{height:var(--avatar-small-medium-size);width:var(--avatar-small-medium-size);min-width:var(--avatar-small-medium-size);font-size:var(--avatar-small-medium-font-size);line-height:var(--avatar-small-medium-line-height);font-weight:var(--avatar-small-medium-font-weight);letter-spacing:var(--avatar-small-medium-letter-spacing)}:host.nx-avatar--small-medium ::ng-deep nx-icon{font-size:var(--avatar-small-medium-icon-size)}:host.nx-avatar--medium{height:var(--avatar-medium-size);width:var(--avatar-medium-size);min-width:var(--avatar-medium-size);font-size:var(--avatar-medium-font-size);line-height:var(--avatar-medium-line-height);font-weight:var(--avatar-medium-font-weight);letter-spacing:var(--avatar-medium-letter-spacing)}:host.nx-avatar--medium ::ng-deep nx-icon{font-size:var(--avatar-medium-icon-size)}:host.nx-avatar--large{height:var(--avatar-large-size);width:var(--avatar-large-size);min-width:var(--avatar-large-size);font-size:var(--avatar-large-font-size);line-height:var(--avatar-large-line-height);font-weight:var(--avatar-large-font-weight);letter-spacing:var(--avatar-large-letter-spacing)}:host.nx-avatar--large ::ng-deep nx-icon{font-size:var(--avatar-large-icon-size)}:host.nx-avatar--xlarge{height:var(--avatar-xlarge-size);width:var(--avatar-xlarge-size);min-width:var(--avatar-xlarge-size);font-size:var(--avatar-xlarge-font-size);line-height:var(--avatar-xlarge-line-height);font-weight:var(--avatar-xlarge-font-weight);letter-spacing:var(--avatar-xlarge-letter-spacing)}:host.nx-avatar--xlarge ::ng-deep nx-icon{font-size:var(--avatar-xlarge-icon-size)}:host.is-button{border:none;padding:0;cursor:pointer;position:relative}:host.is-button:before,:host.is-button ::ng-deep .nx-image:after{content:\"\";width:100%;height:100%;position:absolute;border-radius:50%;top:0;left:0}:host.is-button:hover:not(:disabled):before{background-color:#0000001a}:host.is-button:hover:not(:disabled) ::ng-deep .nx-image:after{background-color:#0000001a}:host.is-button:active:not(:disabled):before{background-color:#0003}:host.is-button:active:not(:disabled) ::ng-deep .nx-image:after{background-color:#0003}:host.is-button:disabled{cursor:not-allowed;opacity:var(--avatar-disabled-opacity)}:host.is-button:focus{outline:none}:host.is-button::-moz-focus-inner{border:0}:host.is-button.cdk-keyboard-focused{box-shadow:var(--focus-box-shadow)}@media screen and (forced-colors: active),(forced-colors: active){:host.is-button.cdk-keyboard-focused{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}@media screen and (forced-colors: active){:host{border:2px solid CanvasText}:host.is-button{border:2px solid buttonText;background-color:buttonFace}:host.is-button:disabled{opacity:1;border-color:GrayText;color:GrayText}}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    size: [{
      type: Input
    }]
  });
})();
class NxAvatarButtonDirective {
  constructor(_elementRef, _focusMonitor) {
    this._elementRef = _elementRef;
    this._focusMonitor = _focusMonitor;
  }
  ngAfterViewInit() {
    this._focusMonitor.monitor(this._elementRef);
  }
  ngOnDestroy() {
    this._focusMonitor.stopMonitoring(this._elementRef);
  }
  static {
    this.ɵfac = function NxAvatarButtonDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxAvatarButtonDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.FocusMonitor));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxAvatarButtonDirective,
      selectors: [["button", "nxAvatar", ""]],
      hostVars: 2,
      hostBindings: function NxAvatarButtonDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("is-button", true);
        }
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxAvatarButtonDirective, [{
    type: Directive,
    args: [{
      selector: 'button[nxAvatar]',
      host: {
        '[class.is-button]': 'true'
      },
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1.FocusMonitor
  }], null);
})();
class NxAvatarModule {
  static {
    this.ɵfac = function NxAvatarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxAvatarModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NxAvatarModule,
      imports: [CommonModule, NxAvatarComponent, NxAvatarButtonDirective],
      exports: [NxAvatarComponent, NxAvatarButtonDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxAvatarModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, NxAvatarComponent, NxAvatarButtonDirective],
      exports: [NxAvatarComponent, NxAvatarButtonDirective]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NxAvatarButtonDirective, NxAvatarComponent, NxAvatarModule };
